import { render, staticRenderFns } from "./ClientDocumentation.vue?vue&type=template&id=4cefcc27&scoped=true&"
import script from "./ClientDocumentation.vue?vue&type=script&lang=js&"
export * from "./ClientDocumentation.vue?vue&type=script&lang=js&"
import style0 from "./ClientDocumentation.vue?vue&type=style&index=0&id=4cefcc27&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cefcc27",
  null
  
)

export default component.exports